import styled from "styled-components";
import { Link } from "react-router-dom";
import { Button, Table } from "semantic-ui-react";

export const Container = styled.div`
  position: relative;
  display: block;
  width: ${props => props.width || '20'}cm;
  height: ${props => props.height || '20'}cm;
  margin: 6% auto;

  border: 2px solid gray;
  ${props => props.image && `
    background-image: url('${props.image}');
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
  `}

  i {
    height: min-content;
  }
`;

export const RndContent = styled.div`
  position: relative; 
  width: 100%; 
  height: 100%; 
  border: 1px dotted gray;
  font-size: ${props => props.fontSize || 20}px;
  display: flex;
  align-items: center;
`;


export const CertificateMenu = styled.ul`
  position: absolute;
  right: 20px;
  top: 30px; 
  width: max-content;
  height: min-content;
  list-style: none;

  & > li {
    display: flex;
    height: 40px;
    transition: 0.15s all ease-in-out;
    cursor: pointer;
    align-items: center;

    &:hover {
      background-color: gray;
    }
  }

  & > label {
    display: flex;
    height: 40px;
    transition: 0.15s all ease-in-out;
    cursor: pointer;
    align-items: center;

    &:hover {
      background-color: gray;
    }
  }
`;